<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.academic.setup.program.grade.grade') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('school.academic.setup.program.grade.grade'),
            href: '/grades'
          },
          {
            text: $t('school.academic.setup.program.grade.edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-6">
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{
                        $t('school.academic.setup.program.grade.main_program')
                      }}
                      <i
                        class="fas fa-question-circle"
                        v-tooltip="
                          $t(
                            'school.academic.setup.program.grade.select_main_program_to_filter_sub_program'
                          )
                        "
                      ></i>
                      <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model="model.acp_id"
                        @change="onMainProgramChange(model.acp_id)"
                      >
                        <option value>--Select--</option>
                        <option
                          v-for="(main, index) in main_programs"
                          :key="index"
                          :value="main.acp_id"
                          >{{ main.acp_name_foreign }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{
                        $t('school.academic.setup.program.grade.sub_program')
                      }}
                      <i
                        class="fas fa-question-circle"
                        v-tooltip="
                          $t(
                            'school.academic.setup.program.grade.select_sub_program_to_filter_level'
                          )
                        "
                      ></i>
                      <i class="fas fa-spinner spin" v-if="fetch_sub"></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model="model.acps_id"
                        @change="
                          onSubProgramChange(model.acps_id, model.acp_id)
                        "
                      >
                        <option value>--selec--</option>
                        <option
                          v-for="(sub, index) in sub_programs"
                          :key="index"
                          :value="sub.acps_id"
                          >{{ sub.acps_name_foreign }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{ $t('school.academic.setup.program.grade.level') }}
                      <i class="fas fa-spinner spin" v-if="fetch_level"></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('level_id') }"
                        v-model.number="model.level_id"
                        @change="getGradeBaseOnMainProgram(model.acp_id)"
                      >
                        <option value>--selec--</option>
                        <option
                          v-for="(level, index) in levels"
                          :key="index"
                          :value="level.level_id"
                          >{{ level.level_name_foreign }}</option
                        >
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('level_id')"
                      >
                        {{ errors.first('level_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">{{
                      $t('school.academic.setup.program.grade.name_kh')
                    }}</label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.grade_name_native"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('grade_name_native')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_name_native')"
                      >
                        {{ errors.first('grade_name_native') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{ $t('school.academic.setup.program.grade.name_en') }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.grade_name_foreign"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('grade_name_foreign')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_name_foreign')"
                      >
                        {{ errors.first('grade_name_foreign') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.abbreviation')
                      }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.grade_abbr"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('grade_abbr') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_abbr')"
                      >
                        {{ errors.first('grade_abbr') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.grade_order')
                      }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="number"
                        v-model.number="model.grade_order"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('grade_order') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_order')"
                      >
                        {{ errors.first('grade_order') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{ $t('school.academic.setup.program.grade.next_grade') }}
                      <i
                        class="fas fa-spinner spin"
                        v-if="fetch_next_grade"
                      ></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model.number="model.next_grade_id"
                      >
                        <option value>--selec--</option>
                        <option
                          v-for="(grade, index) in next_grades"
                          :key="index"
                          :value="grade.grade_id"
                          >{{ grade.grade_name_foreign }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.scoring_type')
                      }}
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('score_type') }"
                        v-model.number="model.score_type"
                        @change="() => (model.sc_bas_id = null)"
                      >
                        <option value>--selec--</option>
                        <option :value="1">Numeric</option>
                        <option :value="2">Grading</option>
                      </select>
                    </div>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('score_type')"
                    >
                      {{ errors.first('score_type') }}
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.monthlyScore')
                      }}
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model.number="model.monthly_score_sc_bas_id"
                        :class="{
                          'is-invalid': errors.has('monthly_score_sc_bas_id')
                        }"
                      >
                        <option :value="null">{{ $t('select') }}</option>
                        <option :value="1">Item Base</option>
                        <option :value="2">Subject Base</option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('monthly_score_sc_bas_id')"
                      >
                        {{ errors.first('monthly_score_sc_bas_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.semesterScore')
                      }}
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model.number="model.semester_score_sc_bas_id"
                        :class="{
                          'is-invalid': errors.has('semester_score_sc_bas_id')
                        }"
                      >
                        <option :value="null">{{ $t('select') }}</option>
                        <option :value="1">Item Base</option>
                        <option :value="2">Subject Base</option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('semester_score_sc_bas_id')"
                      >
                        {{ errors.first('semester_score_sc_bas_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label"></label>
                    <div class="col-md-8">
                      <ts-checkbox v-model="model.attendance_by_subject">
                        {{
                          $t(
                            'school.academic.setup.program.grade.attendance_by_subject'
                          )
                        }}
                      </ts-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2"></div>
            <div class="col-lg-5">
              <div class="tree" v-show="subjects.length">
                <ul>
                  <li>
                    <a :class="{ 'has-error': $v.model.year.$error }">
                      <select
                        v-model="model.year"
                        class="form-control"
                        @input="$v.model.year.$touch()"
                      >
                        <option value="">--Select--</option>
                        <option value="YEAR I">YEAR I</option>
                        <option value="YEAR II">YEAR II</option>
                        <option value="YEAR III">YEAR III</option>
                        <option value="YEAR IV">YEAR IV</option>
                      </select>
                      <span class="help-block" v-if="yearErrors.length > 0">
                        {{ yearErrors[0] }}
                      </span>
                    </a>
                    <ul>
                      <li>
                        <a>SEMESTER I</a>
                        <ul>
                          <li
                            :class="{
                              'has-error':
                                $v.model.subject_list.semester1.subject_id
                                  .$error
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search subject..."
                              v-model="filters.semester1"
                            />
                            <a
                              v-if="semester1Subjects.length"
                              class="subject-list"
                              style="border-top: none;"
                            >
                              <span
                                class="help-block"
                                v-if="semester1Errors.length > 0"
                              >
                                {{ semester1Errors[0] }}
                              </span>
                              <div
                                v-for="subject in semester1Subjects"
                                :key="subject.subject_id"
                                class="d-flex align-items-start subject-item"
                                style="width:270px"
                              >
                                <ts-checkbox
                                  v-model="
                                    model.subject_list.semester1.subject_id
                                  "
                                  :value="subject.subject_id"
                                  >{{ subject.subject_name_foreign }}
                                </ts-checkbox>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a>SEMESTER II</a>
                        <ul>
                          <li
                            :class="{
                              'has-error':
                                $v.model.subject_list.semester2.subject_id
                                  .$error
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search subject..."
                              v-model="filters.semester2"
                            />
                            <a
                              v-if="semester2Subjects.length"
                              class="subject-list"
                              style="border-top: none;"
                            >
                              <span
                                class="help-block"
                                v-if="semester2Errors.length > 0"
                              >
                                {{ semester2Errors[0] }}
                              </span>
                              <div
                                v-for="subject in semester2Subjects"
                                :key="subject.subject_id"
                                class="d-flex align-items-start subject-item"
                                style="width:270px"
                              >
                                <ts-checkbox
                                  v-model="
                                    model.subject_list.semester2.subject_id
                                  "
                                  :value="subject.subject_id"
                                  >{{ subject.subject_name_foreign }}
                                </ts-checkbox>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button
                class="btn-primary mr-2"
                :waiting="waiting"
                @click.prevent="update"
                >{{ $t('update') }}</ts-button
              >
              <ts-button @click="$router.push({ name: 'grade' })">{{
                $t('cancel')
              }}</ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'grade-edit',
  data () {
    return {
      model: {
        grade_id: '',
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_name_native: '',
        grade_name_foreign: '',
        grade_abbr: '',
        grade_order: '',
        next_grade_id: '',
        attendance_by_subject: false,
        subject_list: {
          semester1: {
            semester: 'SEMESTER I',
            subject_id: []
          },
          semester2: {
            semester: 'SEMESTER II',
            subject_id: []
          }
        },
        score_type: 1,
        monthly_score_sc_bas_id: '',
        semester_score_sc_bas_id: '',
        year: ''
      },
      filters: {
        semester1: '',
        semester2: ''
      },
      sub_programs: [],
      levels: [],
      subjects: [],
      next_grades: [],
      ready_fetch: false,
      fetch_sub: false,
      fetch_level: false,
      fetch_subject: false,
      fetch_next_grade: false,
      waiting: false,
      errors: new Errors()
    }
  },
  validations: {
    model: {
      year: { required },
      subject_list: {
        semester1: {
          subject_id: { required }
        },
        semester2: {
          subject_id: { required }
        }
      }
    }
  },
  async created () {
    await this.fetchResourceBeforeCreate()
    await this.setEditData()
  },
  computed: {
    ...mapState('grade', ['main_programs', 'edit_data']),
    semester1Subjects () {
      return this.subjects.filter(
        s =>
          s.subject_name_foreign
            .toLowerCase()
            .indexOf(this.filters.semester1.toLowerCase()) != -1
      )
    },
    semester2Subjects () {
      return this.subjects.filter(
        s =>
          s.subject_name_foreign
            .toLowerCase()
            .indexOf(this.filters.semester2.toLowerCase()) != -1
      )
    },
    yearErrors () {
      const errors = []
      if (!this.$v.model.year.$dirty) return errors
      !this.$v.model.year.required && errors.push('Required')
      return errors
    },
    semester1Errors () {
      const errors = []
      if (!this.$v.model.subject_list.semester1.subject_id.$dirty) return errors
      !this.$v.model.subject_list.semester1.subject_id.required &&
        errors.push('Required')
      return errors
    },
    semester2Errors () {
      const errors = []
      if (!this.$v.model.subject_list.semester2.subject_id.$dirty) return errors
      !this.$v.model.subject_list.semester2.subject_id.required &&
        errors.push('Required')
      return errors
    }
  },
  methods: {
    fetchResourceBeforeCreate () {
      this.ready_fetch = true
      this.$store
        .dispatch('grade/dataBeforeCreate')
        .then(() => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    onMainProgramChange (acp_id) {
      this.model.acps_id = ''
      this.model.level_id = ''
      this.subjects = this.levels = this.next_grades = this.model.subject_list = []
      this.fetch_sub = true
      this.$store
        .dispatch('grade/getSubProgram', acp_id ? acp_id : 0)
        .then(response => {
          this.fetch_sub = false
          this.sub_programs = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_sub = false
        })
    },
    async onSubProgramChange (acps_id, acp_id) {
      this.model.level_id = ''
      this.subjects = this.levels = this.next_grades = this.model.subject_list = []
      this.fetch_level = true
      this.fetch_subject = true
      let level = await this.$store.dispatch(
        'grade/getLevel',
        acps_id ? acps_id : 0
      )
      this.levels = level.data
      this.fetch_level = false
      let subject = await this.$store.dispatch('grade/getSubject', {
        acps_id: acps_id ? acps_id : 0,
        acp_id: acp_id
      })
      this.subjects = subject.data
      this.fetch_subject = false
    },

    async getGradeBaseOnMainProgram (acp_id) {
      if (!acp_id) {
        return
      }
      this.model.next_grade_id = ''
      this.fetch_next_grade = true
      this.$store
        .dispatch('grade/getGrade', acp_id)
        .then(response => {
          this.next_grades = response.data
          this.fetch_next_grade = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_next_grade = false
        })
    },
    update () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }

      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('grade/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'grade' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async setEditData () {
      if (this.edit_data === null || this.edit_data === undefined) return

      await this.onMainProgramChange(
        this.edit_data.level.sub_program.main_program.acp_id
      )
      this.onSubProgramChange(
        this.edit_data.level.sub_program.acps_id,
        this.edit_data.level.sub_program.main_program.acp_id
      )
      this.getGradeBaseOnMainProgram(this.edit_data.level.sub_program.acp_id)

      this.model = {
        grade_id: this.edit_data.grade_id,
        acp_id: this.edit_data.level.sub_program.main_program.acp_id,
        acps_id: this.edit_data.level.sub_program.acps_id,
        level_id: this.edit_data.level_id,
        grade_name_native: this.edit_data.grade_name_native,
        grade_name_foreign: this.edit_data.grade_name_foreign,
        grade_abbr: this.edit_data.grade_abbr,
        grade_order: this.edit_data.grade_order,
        next_grade_id: this.edit_data.next_grade_id,
        attendance_by_subject: this.edit_data.attendance_by_subject,
        score_type: this.edit_data.score_type,
        monthly_score_sc_bas_id: this.edit_data.monthly_score_sc_bas_id,
        semester_score_sc_bas_id: this.edit_data.semester_score_sc_bas_id,
        subject_list: {
          semester1: {
            semester: 'SEMESTER I',
            subject_id: []
          },
          semester2: {
            semester: 'SEMESTER II',
            subject_id: []
          }
        }
      }
      this.edit_data.grade_subjects.map(subj => {
        this.model.year = subj.years
        if (subj.terms === 'SEMESTER I') {
          this.model.subject_list.semester1.subject_id.push(subj.subject_id)
        } else {
          this.model.subject_list.semester2.subject_id.push(subj.subject_id)
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('grade/RESET_STATE')
      this.$store.commit('grade/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
.subject-list {
  padding-left: 20px;
  max-height: 300px;
  overflow-x: scroll;
}
.subject-list ul li {
  padding-left: 7px;
}

.menu-container {
  overflow-x: scroll;
  min-height: 50vh;
  overflow-y: scroll;
}
.tree {
  text-align: center;
  width: max-content;
}
.no-border-bottom {
  border-bottom: none;
}

/*Now the CSS*/
.tree ul {
  margin: 0;
  padding: 0;
  padding-top: 20px;
  position: relative;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 10px 0 10px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*We will use ::before and ::after to draw the connectors*/

.tree li::before,
.tree li::after {
  content: '';
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1px solid #ccc;
  width: 50%;
  height: 20px;
}
.tree li::after {
  right: auto;
  left: 50%;
  border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without 
  any siblings*/
.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
  padding-top: 0;
}

/*Remove left connector from first child and 
  right connector from last child*/
.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}
/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
  border-right: 1px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}
.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #ccc;
  width: 0;
  height: 20px;
}

.tree li a {
  border: 1px solid #ccc;
  padding: 8px 10px;
  text-decoration: none;
  color: #666;
  font-size: 11px;
  white-space: normal;
  display: inline-block;

  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover,
.tree li a:hover + ul li a {
  color: rgb(70, 70, 70);
}
/*Connector styles on hover*/
.tree li a:hover + ul li::after,
.tree li a:hover + ul li::before,
.tree li a:hover + ul::before,
.tree li a:hover + ul ul::before {
  border-color: #94a0b4;
}

::-webkit-scrollbar {
  height: 8px;
  width: 5px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e6e8e9;
}
div::-webkit-scrollbar-thumb:hover {
  background: #bfc0c0;
}
/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}
.tree ul li select {
  border: none;
  -webkit-appearance: none;
  appearance: none;
  text-align: center;
  text-align-last: center;
  outline: white !important;
  cursor: pointer;
}
.tree ul li select:focus {
  outline: 0 !important;
  box-shadow: none !important;
}

option {
  text-align: left;
}
</style>
